<template>
  <div class="mybetgames" v-bind:style="{ paddingBottom: '32px' }" :key="componentKey">
  
    <keep-alive>
      <NavigationBar id="mybetgamesNavigationBarId" ref="mybetgamesNavigationBarRef">
        <template v-if="status === 'create'" v-slot:left>
          <img v-on:click="goBack" class="back" src="../assets/icons/ic_16_back.svg" data-testid="nav-back">
        </template>
        <template v-if="status === 'create'" v-slot:center>
          {{ $t('my_betgames.new_betgame') }}
        </template>
        <template v-else v-slot:center>
          {{ $t('my_betgames.my_betgames') }}
        </template>
        <template v-slot:right>
        </template>
      </NavigationBar>
    </keep-alive>
    
    <div v-if="incomingBetgameTransfers.length > 0" class="list p-top-none mybetgameslist">
      <div class="table-view-title">
        {{ $t('my_betgames.transfer_betgame') }}
      </div>
      <a v-for="(transfer, index) in incomingBetgameTransfers" :key="transfer.bg_betgame.id" href=""
         v-bind:class="{ active : currentBetgame && currentBetgame.id === transfer.bg_betgame.id }"
         v-on:click.stop.prevent="finishBetgameTransfer(transfer.bg_betgame.id)"
         class="table-view-cell" data-testid="my-betgame-transfer">
        <div class="table-view-cell-icon size-24">
          <img v-if="isValidIcon(transfer.icon)" v-bind:src="buildIconPath(transfer.icon, 300)">
          <img v-else src="../assets/icons/ic_24_logo.svg">
        </div>
        <div class="table-view-cell-label">
          {{ transfer.bg_betgame.name }}
        </div>
        <div class="table-view-cell-drilldown"></div>
      </a>
    </div>
    
    <div v-if="this.status !== 'create' && userBetgamesPrivate && userBetgamesPrivate.length > 0" class="list p-top-none mybetgameslist">
      <div class="betgamecard__text">
        <div class="betgamecard__text__label">{{ $t('my_betgames.own_betgames_title') }}</div>
      </div>
      <a v-for="(betgame, index) in userBetgamesPrivate" :key="betgame.id" href=""
         v-bind:class="{ active : currentBetgame && currentBetgame.id === betgame.id }"
         v-on:click.stop.prevent="switchBetgame(betgame.id)"
         class="table-view-cell" data-testid="my-betgame">
        <div class="table-view-cell-icon size-24">
          <img v-if="isValidIcon(betgame.icon)" v-bind:src="buildIconPath(betgame.icon, 300)">
          <img v-else src="../assets/icons/ic_24_logo.svg">
        </div>
        <div class="table-view-cell-label">
          {{ betgame.name }}
          <div v-if="betgame.type !== 'NONE'" class="table-view-cell-label-sublabel">
            <span v-if="currentBetgame && currentBetgame.id === betgame.id">
              {{ $t('active') }}
            </span>
            <span v-if="currentBetgame && currentBetgame.id === betgame.id"> ∙ </span>
            <span v-if="isAdmin(betgame)">{{ $t('admin') }} ∙ </span>
            <span v-else-if="isAuthor(betgame)">{{ $t('author') }} ∙ </span>
            <span v-if="!isTournament(getCompetitionId(betgame.id))">{{ getCompetition(betgame.id) }} ∙ {{ getSeason(betgame.id) }}</span>
            <span v-else>{{ getCompetition(betgame.id) }}</span>
          </div>
          <div v-else class="table-view-cell-label-sublabel">
            <span v-if="currentBetgame && currentBetgame.id === betgame.id">
              {{ $t('active') }}
            </span>
            <span v-if="currentBetgame && currentBetgame.id === betgame.id"> ∙ </span>
            <span v-if="isAdmin(betgame)">{{ $t('admin') }}</span>
            <span v-else-if="isAuthor(betgame)">{{ $t('author') }}</span>
            <span v-if="(isAdmin(betgame) || isAuthor(betgame)) && (betGameType(betgame) === 2 || betGameType(betgame) === 3)"> ∙ </span>
            <span v-if="betGameType(betgame) === 2" style="text-transform: uppercase">{{ $t('create_betgame.select_type_battle') }}</span>
            <span v-else-if="betGameType(betgame) === 3" style="text-transform: uppercase">{{ $t('create_betgame.select_type_teams') }}</span>
          </div>
        </div>
        <div v-if="pendingTipsCount(betgame.id) === 1" class="table-view-cell-value"><span class="indicator indicator--warning">{{ pendingTipsCount(betgame.id) }} {{ $t('one_bet_missing') }}</span></div>
        <div v-else-if="pendingTipsCount(betgame.id) > 1" class="table-view-cell-value"><span class="indicator indicator--warning">{{ pendingTipsCount(betgame.id) }} {{ $t('two_or_more_bets_missing') }}</span></div>
        <div v-else-if="competitionFinished(getCompetitionId(betgame.id), getSeasonId(betgame.id), betgame.id)" class="table-view-cell-value">
          <div class="indicator">{{ $t('betgame_finished') }}</div>
        </div>
        <div class="table-view-cell-drilldown"></div>
      </a>
    </div>
    
    <div v-if="this.status !== 'create' && userBetgamesPublic && userBetgamesPublic.length > 0" class="list p-top-none mybetgameslist">
      <div class="betgamecard__text">
        <div class="betgamecard__text__label">{{ $t('my_betgames.public_betgames_title') }}</div>
      </div>
      <a v-for="(betgame, index) in userBetgamesPublic" :key="betgame.id" href=""
         v-bind:class="{ active : currentBetgame && currentBetgame.id === betgame.id }"
         v-on:click.stop.prevent="switchBetgame(betgame.id)"
         class="table-view-cell" data-testid="my-betgame">
        <div class="table-view-cell-icon size-24">
          <img v-if="isValidIcon(betgame.icon)" v-bind:src="buildIconPath(betgame.icon, 300)">
          <img v-else src="../assets/icons/ic_24_logo.svg">
        </div>
        <div class="table-view-cell-label">
          {{ betgame.name }}
          <div v-if="betgame.type !== 'NONE'" class="table-view-cell-label-sublabel">
            <span v-if="currentBetgame && currentBetgame.id === betgame.id">
              {{ $t('active') }}
            </span>
            <span v-if="currentBetgame && currentBetgame.id === betgame.id"> ∙ </span>
            <span v-if="isAdmin(betgame)">{{ $t('admin') }} ∙ </span>
            <span v-else-if="isAuthor(betgame)">{{ $t('author') }} ∙ </span>
            <span v-if="!isTournament(getCompetitionId(betgame.id))">{{ getCompetition(betgame.id) }} ∙ {{ getSeason(betgame.id) }}</span>
            <span v-else>{{ getCompetition(betgame.id) }}</span>
          </div>
          <div v-else class="table-view-cell-label-sublabel">
            <span v-if="currentBetgame && currentBetgame.id === betgame.id">
              {{ $t('active') }}
            </span>
            <span v-if="currentBetgame && currentBetgame.id === betgame.id"> ∙ </span>
            <span v-if="isAdmin(betgame)">{{ $t('admin') }}</span>
            <span v-else-if="isAuthor(betgame)">{{ $t('author') }}</span>
            <span v-if="(isAdmin(betgame) || isAuthor(betgame)) && (betGameType(betgame) === 2 || betGameType(betgame) === 3)"> ∙ </span>
            <span v-if="betGameType(betgame) === 2" style="text-transform: uppercase">{{ $t('create_betgame.select_type_battle') }}</span>
            <span v-else-if="betGameType(betgame) === 3" style="text-transform: uppercase">{{ $t('create_betgame.select_type_teams') }}</span>
          </div>
        </div>
        <div v-if="pendingTipsCount(betgame.id) === 1" class="table-view-cell-value"><span class="indicator indicator--warning">{{ pendingTipsCount(betgame.id) }} {{ $t('one_bet_missing') }}</span></div>
        <div v-else-if="pendingTipsCount(betgame.id) > 1" class="table-view-cell-value"><span class="indicator indicator--warning">{{ pendingTipsCount(betgame.id) }} {{ $t('two_or_more_bets_missing') }}</span></div>
        <div v-else-if="competitionFinished(getCompetitionId(betgame.id), getSeasonId(betgame.id), betgame.id)" class="table-view-cell-value">
          <div class="indicator">{{ $t('betgame_finished') }}</div>
        </div>
        <div class="table-view-cell-drilldown"></div>
      </a>
    </div>
    
    <div v-if="this.status !== 'create' && !showFinished && (userBetgames && userBetgames.length > 0)" v-on:click="showFinishedBetgames()" class="more-betgames" style="margin-top: 24px; margin-bottom: 24px;" data-testid="my-betgames-show-finished">
      <img src="../assets/icons/ic_24_time_history.svg" alt="">
      {{ finishedBetgamesCount }}
    </div>
    <div v-else-if="this.status !== 'create' && userBetgames && userBetgames.length > 0" v-on:click="hideFinishedBetgames()" class="more-betgames" style="margin-top: 24px; margin-bottom: 24px;" data-testid="my-betgames-hide-finished">
      {{ $t('my_betgames.hide_fnished_betgames') }}
    </div>
      
    <!-- Card Slider -->
    <div v-if="this.status !== 'create' && userBetgames && userBetgames.length > 0 && userBetgamesPublic && userBetgamesPublic.length === 0" class="cardslider" style="overflow: visible;">
      <div class="cardslider__header">
        <h2 class="cardslider__title">{{ $t('my_betgames.public_betgames_title') }}</h2>
        <a v-on:click="showAllClicked" href="#" class="cardslider__link" data-testid="my-betgames-show-all">{{ $t('show_all') }}</a>
      </div>
      <div class="cardslider__wrapper">
        <ul class="cardslider__list">

          <li v-for="challenge in challengesToJoin" v-on:click="navigateToChallenge(challenge)" class="cardslider__card" data-testid="my-betgame-open">
            <div class="cardslider__icon">
              <img v-if="isValidIcon(challenge.icon)" v-bind:src="buildIconPath(challenge.icon, 300)">
              <img v-else src="../assets/icons/ic_24_logo.svg">
            </div>
            <div class="cardslider__body">
              <div class="cardslider__heading">
                <h3 class="cardslider__name">{{ challenge.name }}</h3>
                <img src="../assets/icons/ic_16_drilldown.svg">
              </div>
              <p class="cardslider__meta">{{ formatNumber(challenge.usercount) }} {{ $t('betgame_settings.betgame_participants') }}</p>
            </div>
          </li>
          
          <li class="cardslider__spacer" aria-hidden="true"></li>
        </ul>
      </div>
      <div style=""></div>
    </div>
    
    <div v-if="this.status !== 'create' && userBetgames && userBetgames.length > 0" class="button__wrapper">
      <button v-on:click="status = 'create'" data-testid="my-betgames-create-join"><img class="button-icon button-icon--left" src="../assets/icons/ic_12_plus_white.svg">{{ $t('my_betgames.button_create_join_betgame') }}</button>
    </div>
    
    <!-- Nur sichtbar, wenn der noch nie Teil einer Tipprunde war -->
    <div v-if="this.status === 'create' || !userBetgames || userBetgames.length === 0">

      <!-- Eigene Tipprunde -->
      <div class="betgamecard">
        <img class="button-icon button-icon--left" src="../assets/tff/feature-02-tipprunde.svg">
        <div class="betgamecard__text">
          <div class="betgamecard__text__label">{{ $t('my_betgames.own_betgame_title') }}</div>
          <div class="betgamecard__text__sublabel">{{ $t('my_betgames.own_betgame_text') }}</div>
        </div>
        <router-link to="/createUserBetgame" class="button" data-testid="my-betgames-create"><img src="../assets/icons/ic_12_plus_white.svg" class="button-icon--left">{{ $t('my_betgames.own_betgame_action') }}</router-link>
        <div class="invitation-input">
          <input v-model="invitationLink" type="text" name="invitation_link" id="invitation_link" :placeholder="$t('search_betgame.invitation_link_input')" data-testid="search-betgame-query"/>
          <button @click="invitationLinkClicked()" class="button-secondary" data-testid="search-betgame-submit">{{ $t('betgame_welcome.join_betting_group') }}</button>
        </div>
      </div>

      <!-- Divider -->
      <div class="divider">
        <div class="divider-stroke"></div>
        <div class="divider-label">{{ $t('or') }}</div>
        <div class="divider-stroke"></div>
      </div>

      <!-- Community-Tipprunde -->
      <div class="betgamecard">
        <img class="button-icon button-icon--left" src="../assets/tff/feature-05-community.svg">
        <div class="betgamecard__text">
          <div class="betgamecard__text__label">{{ $t('my_betgames.public_betgames_title') }}</div>
          <div class="betgamecard__text__sublabel">{{ $t('my_betgames.public_betgames_text') }}</div>
        </div>

        <div v-for="challenge in challengesToJoin" @click="navigateToChallenge(challenge)" :key="challenge.id" class="table-view-cell" data-testid="my-betgame-open">
          <div class="table-view-cell-icon size-24">
            <img v-if="isValidIcon(challenge.icon)" v-bind:src="buildIconPath(challenge.icon, 300)">
            <img v-else src="../assets/icons/ic_24_logo.svg">
          </div>
          <div class="table-view-cell-label">
            <span>{{ challenge.name }}</span>
            <div class="table-view-cell-label-sublabel highlighted">
              {{ formatNumber(challenge.usercount) }} {{ $t('betgame_settings.betgame_participants') }}
            </div>
          </div>
          <button><img src="../assets/icons/ic_12_next_white.svg"></button>
        </div>
      </div>
      
      <div style="margin-bottom: 48px;"></div>
      
    </div>
    
  </div>
</template>

<script>
import NavigationBar from './../components/NavigationBar'
import { TOAST_DURATION, TOURNAMENTS } from '../main'
import Vue from 'vue'
import { getAnalytics, setUserProperties } from 'firebase/analytics'

export default {
  name: 'MyBetgames',
  components: {
    NavigationBar
  },
  data() {
    return {
      showFinished: false,
      componentKey: 0,
      invitationLink: '',
      status: 'initial'
    }
  },
  beforeCreate() {
  },
  created() {
    //if (this.$store.state.userBetgames == null || this.$store.state.userBetgames.length === 0 || this.$store.state.missing_bets === undefined) {
      this.$store.dispatch('fetchUserBetgames', this.$store.state.user.id).then(() => {
        Vue.$log.debug('MyBetgames created fetchUserBetgames ')
        this.componentKey += 1
      })
    //}
    this.$store.dispatch('fetchBetgameTransfersByUser', this.$store.state.user.id).then(() => {
      Vue.$log.debug('incomingBetgameTransfers ' + JSON.stringify(this.incomingBetgameTransfers))
    }).catch(function (error) {

    })
    
    if(!this.$store.state.questions && this.$store.state.betgameId && this.$store.state.betgame && this.$store.state.betgame.season) {
      this.$store.dispatch('fetchQuestions', []).then(function (response) {
    })
    }
    if(!this.$store.state.answers && this.$store.state.betgameId && this.$store.state.user) {
      this.$store.dispatch('updateAnswerCount', false).then(function (response) {
      })
      this.$store.dispatch('fetchUserAnswers', []).then(function (response) {
      })
    }
  },
  mounted() {
    Vue.$log.debug('MyBetgames.mounted ' + JSON.stringify(this.$route.query))
    this.$store.dispatch('fetchChallenges').then(() => {
      this.componentKey += 1
    })
    if(this.$route.query && this.$route.query.challenges && this.$route.query.challenges === '1') {
      this.status = 'create'
    }
  },
  computed: {
    finishedBetgamesCount() {
      const p = this.userBetgamesParticipant || []
      const a = this.userBetgamesAuthor || []
      const o = this.userBetgamesOwner || []
      var newArray = p.concat(a).concat(o)
      const that = this
      var temp = newArray.filter(function (item) {
        const c = that.getCompetitionId(item.id)
        const s = that.getSeasonId(item.id)
        return !that.competitionFinished(c, s, item.id)
      });
      return this.$i18n.t('my_betgames.finished_betgames_count', { count: newArray.length - temp.length })
    },
    incomingBetgameTransfers() {
      return this.$store.state.incomingBetgameTransfers
    },
    currentBetgame() {
      return this.$store.state.betgame
    },
    userBetgamesOwner() {
      if(!this.$store.state.betgames_owner) {
        return []
      }
      const newArray = this.$store.state.betgames_owner.filter(function (el) {
        return true;
      });
      return newArray.sort((a, b) => b.id - a.id)
    },
    userBetgamesAuthor() {
      const a = this.$store.state.betgames_author || []
      const o = this.userBetgamesOwner || []
      var newArray = a.filter(function (el) {
        return o.filter(function(item) { return item.id === el.id; }).length === 0;
      });
      return newArray.sort((a, b) => b.id - a.id)
    },
    userBetgamesParticipant() {
      const p = this.$store.state.betgames_participant || []
      const a = this.$store.state.betgames_author || []
      const o = this.userBetgamesOwner || []
      var newArray = p.filter(function (el) {
        return o.filter(function(item) { return item.id === el.id; }).length === 0 &&
                a.filter(function(item) { return item.id === el.id; }).length === 0;
      });
      return newArray.sort((a, b) => b.id - a.id)
    },
    challengesToJoin() {
      const challenges = this.userBetgames || []
      const ub = this.$store.state.challenges || []
      var result = []
      for (var i = 0; i < ub.length; i++) {
        const item = ub[i]
        if(challenges.filter(function (challenge) { return challenge.id === item.id }).length === 0) {
          result.push(item)
        }
      }
      return result
    }, 
    userBetgamesPrivate() {
      const ub = this.userBetgames || []
      const challenges = this.$store.state.challenges || []
      var result = []
      for (var i = 0; i < ub.length; i++) {
        const item = ub[i]
        if(challenges.filter(function (challenge) { return challenge.id === item.id }).length === 0) {
          result.push(item)
        }
      }
      return result
    },    
    userBetgamesPublic() {
      const ub = this.userBetgames || []
      const challenges = this.$store.state.challenges || []
      var result = []
      for (var i = 0; i < ub.length; i++) {
        const item = ub[i]
        if(challenges.filter(function (challenge) { return challenge.id === item.id }).length > 0) {
          result.push(item)
        }
      }
      return result
    },    
    userBetgames() {
      const p = this.userBetgamesParticipant || []
      const a = this.userBetgamesAuthor || []
      const o = this.userBetgamesOwner || []
      /*var newArray = p.filter(function (el) {
        return o.filter(function(item) { return item.id === el.id; }).length === 0 &&
            a.filter(function(item) { return item.id === el.id; }).length === 0;
      });
      */
      var newArray = o.concat(a).concat(p)
       if(this.showFinished) {
         const that = this
         return newArray.sort((a, b) => {
               const ca = that.getCompetitionId(a.id)
               const sa = that.getSeasonId(a.id)
               const cb = that.getCompetitionId(b.id)
               const sb = that.getSeasonId(b.id)
               const fa = that.competitionFinished(ca, sa, a.id)
               const fb = that.competitionFinished(cb, sb, b.id)
               if(fa === fb) {
                 return 0
               } else {
                 return fa ? 1 : -1
               }
             }
         )
      } else {
        const that = this
        var temp = newArray.filter(function (item) {
          const c = that.getCompetitionId(item.id)
          const s = that.getSeasonId(item.id)
          if(parseInt(c) === 0) {
            return !that.hideBetgame(item.id)
          }
          return !that.competitionFinished(c, s, item.id)
        });
        return temp.sort((a, b) => {
              const ca = that.getCompetitionId(a.id)
              const sa = that.getSeasonId(a.id)
              const cb = that.getCompetitionId(b.id)
              const sb = that.getSeasonId(b.id)
              const fa = that.competitionFinished(ca, sa, a.id)
              const fb = that.competitionFinished(cb, sb, b.id)
              if(fa === fb) {
                return 0
              } else {
                return fa ? 1 : -1
              }
            }
        )
      }
    },
    userId() {
      return this.$store.state.user.id
    }
  },
  methods: {
    formatNumber(value) {
      if(this.isNumeric(value)) {
        return new Intl.NumberFormat(this.$i18n.locale).format(value)
      }
      return value
    },  
    goBack() {
      this.status = 'initial'
    },
    showAllClicked() {
      this.status = 'create'
    },
    invitationLinkClicked() {
      if(this.invitationLink.length > 0) {
        const regex = /^https?:\/\/[^/]+\/join\/\d+\/\d+$/;
        const isMatch = regex.test(this.invitationLink)
        if(isMatch) {
          const match = this.invitationLink.match(/\/join\/(\d+)\/(\d+)$/)
          if (match) {
            const first = match[1]
            const second = match[2]
            this.$router.push({ path: '/join/' + first + '/' + second })
          }
        }
      } else {
        this.$toast.open({ message: this.$i18n.t('my_betgames.invitation_link_empty'), position: 'top', duration: TOAST_DURATION, type: 'error' })
      }
    },
    navigateToChallenge(challenge) {
      this.$router.push({ path: '/join/' + challenge.id + '/' + challenge.invitation_code })
    },
    getNotificationPreferences() {
      var notification_preferences = ''
      if(this.$store.state.user) {
        if(this.$store.state.user.email_notifications !== undefined && this.$store.state.user.email_notifications === true) {
          notification_preferences += 'MReminder,'
        }
        if(this.$store.state.user.push_notifications !== undefined && this.$store.state.user.push_notifications === true) {
          notification_preferences += 'PReminder,'
        }
        if(this.$store.state.user.news_email_notifications !== undefined && this.$store.state.user.news_email_notifications === true) {
          notification_preferences += 'MNews,'
        }
        if(this.$store.state.user.news_push_notifications !== undefined && this.$store.state.user.news_push_notifications === true) {
          notification_preferences += 'PNews,'
        }
        if(this.$store.state.user.chat_push_notifications !== undefined && this.$store.state.user.chat_push_notifications === true) {
          notification_preferences += 'PChat,'
        }
      }
      if(notification_preferences === '') {
        notification_preferences = 'none'
      }
      return notification_preferences
    },
    betGameType(betgame) {
      if(!this.$store.state.userBetgames) {
        return 0
      }
      const t = this.$store.state.userBetgames.filter(function (item) {
        return item.id === betgame.id
      });
      return t.length > 0 ? t[0].type : 0
    },
    isTournament(competition) {
      return TOURNAMENTS.includes(parseInt(competition))
    },
    isAdmin(betgame) {
      if(!this.userBetgamesOwner) {
        return false
      }
      const t = this.userBetgamesOwner.filter(function (item) {
        return item.id === betgame.id
      });
      return t.length > 0
    },
    isAuthor(betgame) {
      if(!this.userBetgamesAuthor) {
        return false
      }
      const t = this.userBetgamesAuthor.filter(function (item) {
        return item.id === betgame.id
      });
      return t.length > 0
    },
    showFinishedBetgames() {
      this.showFinished = true
    },
    hideFinishedBetgames() {
      this.showFinished = false
    },
    pendingAnswersCount(betgame) {
      if(this.$store.state.questions) {
        const questions = this.$store.state.questions.filter(q => parseInt(q.fk_betgame) === parseInt(betgame))
        var result = 0
        for (var i = 0; i < questions.length; i++) {
          const question = questions[i]
          const editableUntil = this.parseMatchdate(question.editable_until)
          if(editableUntil > Date.now() && this.$store.state.answers) {
            const answers = this.$store.state.answers.filter(a => parseInt(a.fk_question) === parseInt(question.id))
            if(answers.length !== question.answer_count) {
              result += question.answer_count
            }
          }
        }
        return result
      }
      return 0
    },
    pendingTipsCount(betgame) {
      if(!this.$store.state.missing_bets) {
        return this.pendingAnswersCount(betgame)
      }
      var newArray = this.$store.state.missing_bets.filter(d => d.id === betgame)
      if(newArray.length > 0) {
        return (newArray[0].matchcount - newArray[0].betcount) + this.pendingAnswersCount(betgame)
      }
      return this.pendingAnswersCount(betgame)
    },
    finishBetgameTransfer(betgame) {
      Vue.$log.debug('finishBetgameTransfer ' + betgame)
      const that = this
      this.$store.dispatch('finishBetgameTransfer', '' + betgame).then(() => {
        that.$toast.open({ message: that.$i18n.t('my_betgames.transfer_betgame_success'), position: 'top', duration: TOAST_DURATION, type: 'success' })
        that.switchBetgame(betgame)
      }).catch(function (error) {
        alert(that.$i18n.t('my_betgames.transfer_betgame_error') + ' ' + error)
      })
    },
    switchBetgame(betgame) {
      if(!this.currentBetgame || this.currentBetgame.id !== betgame) {
        this.setBGValue('spmbgid', betgame)
        if(navigator.userAgent.indexOf('TEAMTIP') > 0 || navigator.userAgent.indexOf('Teamtip') > 0) {
          this.setBGValue('betgameId', betgame)
        }
        this.$store.dispatch('switchBetgame', betgame).then(() => {
          this.$gtag.set({
            'dimension1': (this.$store.state.betgame && this.$store.state.betgame.id === betgame && this.$store.state.betgame.name) ? this.$store.state.betgame.name : 'betgame not set',
            'dimension2': this.$store.state.user && this.$store.state.user.source ? this.$store.state.user.source : 'user source not set',
            'dimension3': betgame ? betgame : 'betgame id not set',
            'dimension5': this.$store.state.betgame && this.$store.state.betgame.type ? this.$store.state.betgame.type : 'betgame type not set'
          })
          if(this.$store.state.betgame && this.$store.state.user) {
            this.$gtag.set({
              user_properties: {
                permission_manage_prediction_round: '' + this.isAdmin(this.$store.state.betgame.id),
                prediction_mode: this.getBetgameType(this.$store.state.betgame),
                prediction_competiton: this.getCompetitionId(this.$store.state.betgame.id),
                betgame_id: '' + this.$store.state.betgame.id,
                notification_preferences: this.getNotificationPreferences(),
                news_push: (this.$store.state.user.news_push_notifications !== undefined && this.$store.state.user.news_push_notifications === true) ? '1' : '0',
                user_age: (this.$store.state.user.isadult) ? '>=18' : '<18',
                test_spm: (this.isSPMUser()) ? '1' : '0'
              },
            })
            if (window.webkit && window.webkit.messageHandlers.TeamtipAppInterface !== undefined && window.webkit.messageHandlers.TeamtipAppInterface !== null) {
              const c = window.webkit.messageHandlers.TeamtipAppInterface.postMessage({
                'type': 'setFirebaseUserProperty',
                'permission_manage_prediction_round': '' + this.isAdmin(this.$store.state.betgame.id),
                'prediction_mode': this.getBetgameType(this.$store.state.betgame),
                'prediction_competiton': '' + this.getCompetitionId(this.$store.state.betgame.id),
                'betgame_id': '' + this.$store.state.betgame.id,
                'notification_preferences': this.getNotificationPreferences(),
                'news_push': (this.$store.state.user.news_push_notifications !== undefined && this.$store.state.user.news_push_notifications === true) ? '1' : '0',
                'user_age': (this.$store.state.user.isadult) ? '>=18' : '<18',
                'test_spm': (this.isSPMUser()) ? '1' : '0'
              })
            } else if (window.TeamtipAppInterface !== undefined && window.TeamtipAppInterface !== null) {
              const data = {
                type: 'setFirebaseUserProperty',
                permission_manage_prediction_round: '' + this.isAdmin(this.$store.state.betgame.id),
                prediction_mode: this.getBetgameType(this.$store.state.betgame),
                prediction_competiton: '' + this.getCompetitionId(this.$store.state.betgame.id),
                betgame_id: '' + this.$store.state.betgame.id,
                notification_preferences: this.getNotificationPreferences(),
                news_push: (this.$store.state.user.news_push_notifications !== undefined && this.$store.state.user.news_push_notifications === true) ? '1' : '0',
                user_age: (this.$store.state.user.isadult) ? '>=18' : '<18',
                test_spm: (this.isSPMUser()) ? '1' : '0'
              }
              window.TeamtipAppInterface.setFirebaseUserProperty(JSON.stringify(data))
            } else {
              const analytics = getAnalytics()
              setUserProperties(analytics, { permission_manage_prediction_round: '' + this.isAdmin(this.$store.state.betgame.id) })
              setUserProperties(analytics, { prediction_mode: this.getBetgameType(this.$store.state.betgame) })
              setUserProperties(analytics, { prediction_competiton: '' + this.getCompetitionId(this.$store.state.betgame.id) })
              setUserProperties(analytics, { betgame_id: '' + this.$store.state.betgame.id })
              setUserProperties(analytics, { notification_preferences: this.getNotificationPreferences() })
              setUserProperties(analytics, { news_push:  (this.$store.state.user.news_push_notifications !== undefined && this.$store.state.user.news_push_notifications === true) ? '1' : '0'})
              setUserProperties(analytics, { user_age:  (this.$store.state.user.isadult) ? '>=18' : '<18'})
              setUserProperties(analytics, { test_spm: (this.isSPMUser()) ? '1' : '0' })
            }
          }
          this.goToDashboardAfterSwitch()
        })
      } else {
        this.setBGValue('spmbgid', betgame)
        if(navigator.userAgent.indexOf('TEAMTIP') > 0 || navigator.userAgent.indexOf('Teamtip') > 0) {
          this.setBGValue('betgameId', betgame)
        }
        this.$store.dispatch('switchBetgame', betgame).then(() => {
          this.$gtag.set({
            'dimension1': (this.$store.state.betgame && this.$store.state.betgame.id === betgame && this.$store.state.betgame.name) ? this.$store.state.betgame.name : 'betgame not set',
            'dimension2': this.$store.state.user && this.$store.state.user.source ? this.$store.state.user.source : 'user source not set',
            'dimension3': betgame ? betgame : 'betgame id not set',
            'dimension5': this.$store.state.betgame && this.$store.state.betgame.type ? this.$store.state.betgame.type : 'betgame type not set'
          })
          if(this.$store.state.betgame && this.$store.state.user) {
            this.$gtag.set({
              user_properties: {
                permission_manage_prediction_round: '' + this.isAdmin(this.$store.state.betgame.id),
                prediction_mode: this.getBetgameType(this.$store.state.betgame),
                prediction_competiton: this.getCompetitionId(this.$store.state.betgame.id),
                betgame_id: '' + this.$store.state.betgame.id,
                notification_preferences: this.getNotificationPreferences(),
                news_push: (this.$store.state.user.news_push_notifications !== undefined && this.$store.state.user.news_push_notifications === true) ? '1' : '0',
                user_age: (this.$store.state.user.isadult) ? '>=18' : '<18',
                test_spm: (this.isSPMUser()) ? '1' : '0'
              },
            })
          }
          this.goToDashboardAfterSwitch()
        })
      }
    },
    goToDashboardAfterSwitch () {
      if (this.$store.state.user && !this.$store.getters.hasCachedDashboardData) {
        this.$store.dispatch('setShowLoadingOverlay', true).then(() => {
          this.$router.push('/feed/dashboard')
        })
      } else {
        this.$router.push('/feed/dashboard')
      }
    },
  }
}

</script>

<style lang="scss" scoped>

.mybetgameslist {
  margin-top: 16px;
}

.mybetgames {
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
  max-width: 576px;
  margin: 0 auto auto auto;

  @media screen and (min-width: 768px) {
    margin: 48px auto 0;
  }

  .table-view-cell:last-child {
    border-bottom: 0;
  }

  .table-view-cell-label {
    word-break: break-word;
  }

  .table-view-cell-value {
    flex-shrink: 0;
  }

  .indicator {
    padding: 5px 8px;
    border-radius: 10px;
    font-size: 9px;
    font-weight: 500;
    color: rgba($colorGreyDark, .64);
    background: rgba($colorGreyDark, .08);

    &--warning {
      color: $colorWhite;
      background: $colorNegative;
    }
  }

  .active {
    background: rgba($colorGreyLight, .04);
    padding-left: 0;

    &:before, &:after {
      content: '';
      position: absolute;
      width: 16px;
      height: 100%;
      top: 0;
      background: rgba($colorGreyLight, .04);
      border-radius: 0;
    }

    &:before {
      left: -16px;
    }

    &:after {
      right: -16px;
    }

    .table-view-cell-icon {
      position: relative;

      &:before {
        content: '';
        position: absolute;
        right: -2px;
        bottom: -2px;
        width: 10px;
        height: 10px;
        border-radius: 6px;
        background: $colorPositive;
        box-shadow: 0 0 0 2px #F9F9F9;
      }
    }

    .table-view-cell-value {
      display: flex;
    }

    .table-view-cell-label-sublabel {
      span {

        &:first-child {
          color: $colorPositive;
          font-weight: 500;
        }
      }
    }
  }
}

.more-betgames {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  line-height: 20px;
  color: rgba($colorGreyDark, .48);
  text-decoration: underline;
  margin: 18px 0 0;
  cursor: pointer;

  img {
    opacity: .48;
    margin-right: 4px;
  }
}

.button__wrapper {
  position: sticky;
  z-index: 3;
  bottom: 16px;
  padding: 32px 0 0;

  &:before {
    content: '';
    position: absolute;
    z-index: -1;
    top: 0;
    left: -16px;
    width: calc(100% + 32px);
    height: calc(100% + 16px);
    background: linear-gradient(180deg, rgba($colorBackground,0.00) 0%, $colorBackground 50%);
  }
}

.table-view-cell-icon {
  img {
    width: 24px;
    height: 24px;
    object-fit: cover;
    overflow: hidden;
    border-radius: 3px;
  }
}

.router_link {
  text-decoration: none;
}

.betgamecard {
  background: $colorWhite;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.08);
  margin-top: 16px;

  &__text {
    margin: 16px 0 20px;

    &__label {
      font-size: 17px;
      font-weight: 500;
      color: $colorGreyDark;
      margin-bottom: 8px;
    }

    &__sublabel {
      font-size: 14px;
      color: rgba($colorGreyDark, .48);
    }
  }

  .table-view-cell {

    &:last-of-type {
      margin-bottom: -12px;
    }
  
    .button, button {
      width: auto;
      padding: 8px;
    }

    &-label-sublabel {
      font-size: 14px;

      .highlighted {
        font-weight: 500;
        color: var(--color-primary);
      }
    }

  }
}

.textlink-betgame {
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  padding: 8px 0;
  margin: 16px;
  text-align: center;
  color: rgba($colorGreyDark, .48);
}

.invitation-input {
  position: relative;
  dispaly: flex;

  input {
    background: rgba($colorGreyDark, .08);
    border: 0;
    font-size: 17px;
    width: 100%;
    padding: 14px 0;
    margin: 16px 0 0 0;
    text-align: center;
    border-radius: 6px;
    color: $colorGreyDark;

    &:focus {
      outline: 0;
      box-shadow: inset 0 0 0 1px rgba($colorGreyLight, .12);
    }

    ~ button {
      position: absolute;
      left: 8px;
      bottom: 8px;
      width: calc(100% - 16px);
      display: none;
      opacity: 0;
      padding: 10px;
    }

    &:not(:placeholder-shown) {
      padding: 14px 0 64px;
      
      ~ button {
        opacity: 1;
        display: inline-block;
      }
    }
  }
}

.divider {
  display: flex;
  align-items: center;
  margin: 22px 0 24px;

  &-stroke {
    flex: 1;
    height: 1px;
    background: linear-gradient(90deg,rgba($colorGreyDark, 0) 0%, rgba($colorGreyDark, .16) 100%);

    &:last-of-type {
      transform: rotate(180deg);
    }
  }

  &-label {
    margin: 0 8px;
    font-size: 14px;
    color: rgba($colorGreyDark, .56);
    text-transform: uppercase;
  }
}

.cardslider {
  display: flex;
  flex-direction: column;
  width: calc(100% + 32px);
  margin: auto -16px -24px;
  overflow: hidden;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    line-height: 22px;
    padding: 0 16px;
    margin-bottom: -8px;
  }

  &__title {
    margin: 0;
    font-size: 14px;
    font-weight: 400;
    color: #000;
  }

  &__link {
    color: rgba(0, 0, 0, 0.56);
    text-decoration: underline;
    text-underline-offset: 2px;
  }

  // Scroll-Container: 100% Breite, horizontal scrollbar, Snap auf linke Kante
  &__wrapper {
    width: 100%;
    padding: 16px 16px;
    scroll-padding-left: 16px;
    scroll-padding-right: 16px;
    box-sizing: border-box;

    overflow-x: auto;
    overflow-y: hidden;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none; // Firefox

    &::-webkit-scrollbar {
      display: none; // WebKit
    }
  }

  &__list {
    display: flex;
    gap: 8px;
    margin: 0;
    padding: 0;
    list-style: none;

    &::after {
    content: '';
    flex: 0 0 1px;
  }
  }

  &__card {
    flex: 0 0 160px;
    width: 160px;
    scroll-snap-align: start;
    scroll-snap-stop: always;

    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;

    background: #fff;
    border-radius: 8px;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.08);
  }

  &__icon {
    width: 24px;
    height: 24px;
    flex-shrink: 0;

    img, .flag {
      display: flex;
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 50%;
      background: rgba(0,0,0,.1);
    }
  }

  &__body {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  &__heading {
    display: flex;
    align-items: center;

    img {
      transform: translateY(-1px);
    }
  }

  &__name {
    margin: 0;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: $colorGreyDark;
    white-space: nowrap;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  &__meta {
    margin: 0;
    font-size: 11px;
    line-height: 14px;
    color: rgba($colorGreyDark, .56);
  }
}

</style>
